import { render, staticRenderFns } from "./TotalRegions.vue?vue&type=template&id=dbde6930&scoped=true"
import script from "./TotalRegions.vue?vue&type=script&lang=js"
export * from "./TotalRegions.vue?vue&type=script&lang=js"
import style0 from "./TotalRegions.vue?vue&type=style&index=0&id=dbde6930&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbde6930",
  null
  
)

export default component.exports